import "common/js/script/globals";
import "common/js/script/menu";

import Accordion from "common/js/script/accordion";
import Bilder from "common/js/script/bilder";
import Video from "common/js/script/video";
import Sok from "common/js/script/sok";
import Observe from "./script/observe";
import changeEpiQuickNavigatorEditLink from "common/js/script/changeEpiQuickNavigatorEditLink";

import InitVue from "./vue/initvue";

Accordion.initAccordion();
Bilder.initBilder();
Video.initVideo();
Sok.initSok();
changeEpiQuickNavigatorEditLink.init();

InitVue.initVue();

// Monitor changes in main and mainbody
// caused by navigation in menus
Observe.observe();
